import { render, staticRenderFns } from "./FundingDetails.vue?vue&type=template&id=fb463c54&scoped=true&"
import script from "./FundingDetails.vue?vue&type=script&lang=js&"
export * from "./FundingDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetails.vue?vue&type=style&index=0&id=fb463c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb463c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
